import React, { useState } from 'react';
import { Transition } from '@headlessui/react';
import { BiMinus, BiPlus } from 'react-icons/bi';

function groupArrayElements<T>(array: T[], groupSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += groupSize) {
    result.push(array.slice(i, i + groupSize));
  }
  return result;
}

export function FaqSection(props: any) {
  const [expanded, setExpanded] = useState<number | null>(null);
  const faqs = groupArrayElements(
    React.Children.toArray(props.children).filter((x) => !!x && typeof x !== 'string'),
    2
  );
  return (
    <section>
      <div className='tw:flex tw:flex-col tw:gap-2.5'>
        {faqs.map((faq, index) => {
          const [question, answer] = faq;
          if (!question || !answer) return null;
          // @ts-ignore
          const questionWithProps = React.cloneElement(question, {
            onClick: () => {
              setExpanded(index === expanded ? null : index);
            },
            isExpanded: index === expanded,
          });
          // @ts-ignore
          const answerWithProps = React.cloneElement(answer, {
            isExpanded: index === expanded,
          });
          return <FaqItem key={index} question={questionWithProps} answer={answerWithProps} />;
        })}
      </div>
    </section>
  );
}

export function FaqAnswer({ children, isExpanded }: any) {
  return (
    <Transition
      show={isExpanded}
      enter='tw:transition tw:duration-500'
      enterFrom='tw:opacity-0 tw:translate-y-[-10px]'
      enterTo='tw:opacity-100 tw:translate-y-0'>
      <p className='tw:mt-3 tw:text-sm tw:text-neutral-600'>{children}</p>
    </Transition>
  );
}

export function FaqQuestion({ children, onClick, isExpanded }: any) {
  return (
    <div
      role='button'
      className='tw:flex tw:items-center tw:justify-between tw:gap-5 tw:text-black'
      onClick={onClick}>
      <p className='tw:my-0 tw:text-base tw:font-bold'>{children}</p>
      {isExpanded ? <BiMinus size={18} /> : <BiPlus size={18} />}
    </div>
  );
}

export function FaqItem({ question, answer }: any) {
  return (
    <div className='tw:rounded-xl tw:bg-gray-100 tw:px-5 tw:py-3'>
      {question}
      {answer}
    </div>
  );
}
